(function() {
    /* globals $, angular */
    'use strict';

    angular.module('dashboardApp').controller('appsController', Controller);
    Controller.$inject = [
        'Login',
        'Apps',
        'Routing'
    ];

    function Controller (
        Login,
        Apps,
        Routing
    ) {

        var vm = this;

        vm.showProgress = true;
        vm.showError = false;

        vm.data = null;

        vm.onAppClick = function() {
            vm.showProgress = true;
        };



        function getAppList() {
            vm.showProgress = true;
            vm.showError = false;

            Apps.list().then(function(response) {
                vm.showProgress = false;
                vm.showError = false;
                vm.data = response;

            }).catch(function() {
                vm.showProgress = false;
                vm.showError = true;

            });
        }



        //----------- initialization ------------------

        function init() {
            Login.check().then(function(success) {
                if (success) {
                    getAppList();
                } else {
                    Routing.login();
                }
            });
        }


        init();


    }



})();
